import React from 'react'
import PropTypes from 'prop-types'

class ScrollToElement extends React.Component {
  
  handleClick = (target, tracking) => {
    const { scrollTo } = this.context
    if (scrollTo) scrollTo(target)
    
    typeof window !== "undefined" && window.gtag('event', 'clickMissionButtonCTA',{
      'event_category': 'mission',
      'event_label': tracking.id + ' - ' + tracking.name,
      'event_value': 1
    })
  }

  render() {
    const { props } = this
    const { target, children, Parent, tracking, ...rest } = props
    return (
      <Parent
        {...rest}
        onClick={() => this.handleClick(target, tracking)}
        >
        {children}
      </Parent>
    )
  }
}

export default ScrollToElement

ScrollToElement.contextTypes = {
  scrollTo: PropTypes.func.isRequired,
}